const CONFIGS = {
  // ************************ staging URL *************************
  // serverPath: "https://checkout.staging.tap.company/api",
  // framePath: "https://checkout.staging.tap.company/"

  // ************************ sandbox URL *************************
  // serverPath: "https://sandbox-checkout.payments.tap.company/api",
  // framePath: "https://sandbox-checkout.payments.tap.company/",

  // ************************ production URL *************************
  serverPath: "https://checkout.payments.tap.company/api",
  framePath: "https://checkout.payments.tap.company/",

  // ************************ localhost URL *************************
  // serverPath: "http://localhost:8000",
  // framePath: "http://localhost:3000/",

  // ************************ CDN *************************
  imgsPath: "https://goselljslib.b-cdn.net/v1.3/imgs/",
  fontsPath: "https://goSellJSLib.b-cdn.net/fonts/",
  cssPath: "https://goSellJSLib.b-cdn.net/css/"
}

export { CONFIGS }
